export default "__VITE_ASSET__CmkX2ZlN__"